
export const en = {
  translation: {
    common: {
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      create: "Create",
      new: "New",
      search: "Search...",
      loading: "Loading...",
      export: "Export",
      all: "All",
      open: "Open",
      closed: "Closed",
      back: "Back",
      confirm: "Confirm",
      scan: "Scan",
      view_all: "View all",
      show_more: "Show more",
      logout: "Logout",
      work_in_progress: "Work in progress",
      user: "User",
      saving: "Saving...",
      unknown: "Unknown",
      select: "Select...",
      save_success: "Changes saved successfully",
      save_error: "Error saving changes",
      unexpected_error: "Unexpected error",
      save_changes: "Save Changes",
      delete_confirm_title: "Delete Confirmation",
      delete_success: "Deleted successfully",
      delete_error: "Error deleting",
      activate: "Activate",
      deactivate: "Deactivate",
      add: "Add",
      no_data: "No data available",
      no_options: "No options",
      days: {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
      },
      org_missing: "Organization missing",
      error: "Error",
      connection_error: "Connection error"
    },
    date_picker: {
      placeholder: "Select date",
      days_short: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    },
    roles: {
      admin: "Owner",
      manager: "Manager",
      staff: "Staff",
      user: "User"
    },
    login: {
      welcome_back: "Welcome Back",
      create_account: "Create Account",
      subtitle: "Sign in to manage your salon.",
      email: "Email",
      password: "Password",
      forgot_password: "Forgot password?",
      signin_btn: "Sign In",
      signup_btn: "Sign Up",
      no_account: "Don't have an account?",
      has_account: "Already have an account?",
      signup_link: "Sign up now",
      signin_link: "Sign in",
      check_email: "Check your email for the confirmation link!",
      error_generic: "An error occurred during authentication."
    },
    sidebar: {
      HOME: "Home",
      CALENDAR: "Calendar",
      CUSTOMERS: "Customers",
      STAFF: "Staff",
      ANALYTICS: "Analytics",
      ASSISTANT: "AI Assistant",
      SALON: "Salon",
      BILLING: "Billing",
      INVENTORY: "Inventory",
      MEDIA: "Media Creation",
      PROFILE: "Profile",
      SETTINGS: "Settings"
    },
    home: {
      greeting: "Hello {{name}}, good to see you again!",
      subtitle: "Your salon is ready for a great day.",
      subtitle_today_count_one: "You have {{count}} appointment scheduled today",
      subtitle_today_count_other: "You have {{count}} appointments scheduled today",
      subtitle_today_empty: "No appointments scheduled for today",
      get_boost: "Get Boost",
      new_appointment: "New Appointment",
      new_appointment_desc: "Got a walk-in or a call? Add the booking in a few seconds.",
      book_now: "Book Now",
      view_agenda: "View Agenda",
      active_agenda: "Active Agenda",
      revenue_month: "October Revenue",
      weekly_activity: "Weekly Activity",
      confirmed_bookings: "Confirmed bookings",
      total: "Total",
      upcoming_appointments: "Upcoming Appointments",
      view_all: "View all",
      revenue_today_title: "Today's revenue",
      bookings_today: "Appointments today",
      weekly_empty_state: "No data available for this week",
      no_upcoming_appointments: "No upcoming appointments",
      upcoming_placeholder_subtitle: "The next appointment will appear here.",
      more_upcoming: "more upcoming appointments",
      unknown_service: "Unknown service",
      unknown_client: "Unknown client",
      unknown_staff: "Staff",
      tooltip_day_label: "Day",
      tooltip_bookings_label: "Bookings",
      tooltip_revenue_label: "Revenue"
    },
    calendar: {
      today: "Today",
      day: "Day",
      week: "Week",
      month: "Month",
      new_appointment: "New",
      staff_agenda: "Agenda of:",
      free: "Free",
      busy: "Busy",
      full: "Full",
      more_than_n_parallel: "More than {{count}} in parallel",
      n_appointments: "+{{count}} Appointments",
      no_service_for_staff: "The selected staff has no assigned services.",
      all_staff_busy: "No staff member is available at this time.",
      shop_closed: "The salon is closed on this day or at this time.",
      outside_hours: "Time is outside opening hours or staff shift.",
      overlap_break: "The selected time overlaps with a break.",
      overlap_booking: "There is already a booking in this slot for this staff member.",
      overlap_vacation: "The staff member is on vacation or has time off during this period.",
      overlapping_error: "Unable to move the appointment.",
      staff_no_service: "This staff member does not offer this service with the same duration/price.",
      event_updated: "Appointment updated successfully.",
      confirm_move_title: "Move appointment",
      confirm_move_desc: "Are you sure you want to confirm moving this appointment?"
    },
    download_app: {
      loading: "Loading...",
      not_found_title: "Salon not found",
      not_found_desc: "We couldn't find the information for this salon. Make sure the link is correct.",
      book_now: "Book now at",
      why_use_app: "Why use the app",
      feature_1: "Book 24/7 in seconds",
      feature_2: "Manage your appointments",
      feature_3: "Receive automatic reminders",
      download_free: "Download Clip for free"
    },
    customers: {
      title: "Customers",
      subtitle: "Manage your client database and history.",
      new_customer: "New Customer",
      appointments: "Storico Appuntamenti",
      last_visit: "Last visit",
      verified: "Verified",
      not_verified: "Not Verified",
      never_visited: "Never visited",
      discover_duplicates: "Discover Duplicates",
      merged_badge: "Merged",
      duplicates: {
        title: "Resolve Duplicates",
        description: "We grouped customers sharing the same phone number or email. Customers who only have the same full name are not listed: they are different people. Select a group to merge their profiles into one, their appointment history will remain intact.",
        group: "Group",
        profiles: "Profiles",
        common_phone: "Common phone",
        common_email: "Common email",
        empty_title: "No duplicates found",
        empty_description: "There are no customers sharing the same phone number or email.",
        merging: "Merging...",
        merge_selected: "Merge Selected",
        merge_confirm_title: "Merge selected customers?",
        merge_confirm_desc: "This action will permanently merge the selected profiles.",
        merge_confirm_btn: "Confirm Merge"
      },
      modal: {
        title: "Customer Profile",
        create_title: "New Customer",
        create_subtitle: "Add a new customer to the database.",
        email: "Email",
        phone: "Phone",
        notes: "Notes & Preferences",
        delete: "Delete Customer",
        save_changes: "Save Changes",
        customer_since: "Customer since",
        no_name: "Unnamed customer",
        name: "First Name",
        surname: "Last Name",
        create_btn: "Create Customer",
        email_optional: "Email (Optional)",
        phone_optional: "Phone (Optional)",
        no_notes: "No notes available for this customer.",
        no_appointments: "No appointments registered.",
        confirm_title: "Confirm action?",
        blocked: "Blocked",
        block: "Block",
        unblock: "Unblock",
        delete_confirm_desc: "This action will permanently delete {{name}}. This action cannot be undone.",
        block_confirm_desc: "This action will block {{name}} from booking at the salon.",
        unblock_confirm_desc: "This action will unblock {{name}} for bookings at the salon.",
        reset_reports_title: "Reset Reports",
        reset_reports_confirm_desc: "This action will permanently delete all reports for {{name}}. This action cannot be undone.",
        reset: "Reset",
        archived_title: "Archived Customer",
        archived_description: "This profile has been merged with another profile. You cannot edit or delete data from this view.",
        toast: {
          name_required: "First name is required",
          phone_required: "Phone number is required",
          update_error: "Error updating customer",
          update_success: "Customer updated successfully",
          delete_error: "Error deleting customer",
          delete_success: "Customer deleted successfully",
          block_error: "Error blocking customer",
          block_success: "Customer blocked successfully",
          unblock_error: "Error unblocking customer",
          unblock_success: "Customer unblocked successfully",
          op_error: "Error during operation"
        }
      }
    },
    bookings: {
      status_confirmed: "Confirmed",
      status_pending: "Pending",
      status_cancelled: "Cancelled",
      status_no_show: "No-Show",
      modal: {
        title: "Booking Details",
        subtitle: "View reservation details.",
        created_at: "Booked on: {{date}}",
        delete_confirm: "Are you sure you want to delete this booking? This action cannot be undone.",
        delete_error: "Error deleting booking",
        delete_success: "Booking deleted successfully",
        delete_unexpected: "Unexpected error deleting booking.",
        service: "Service",
        service_not_found: "Service not found",
        hairdresser: "Staff",
        hairdresser_not_found: "Staff not found",
        client: "Customer",
        client_not_found: "Customer not found",
        call_client: "Call",
        notes: "Notes",
        edit_btn: "Edit Booking",
        delete_btn: "Delete",
        report_success: "Customer reported successfully",
        client_blocked_title: "Attention: Customer blocked",
        client_blocked_desc: "This customer is blocked and cannot make online bookings",
        report_warning: "Attention: Customer reported",
        report_reason: "Reason for report:",
        report_no_reason: "No reason specified",
        report_and_block_btn: "Report and block",
        report_btn: "Report",
        blocked_title: "Blocked",
        reports_count: "Reports",
        no_show_success: "Status updated to No Show",
        no_show_banner_title: "Missed Appointment (No-Show)",
        no_show_banner_desc: "The customer did not show up for this appointment."
      },
      report: {
        reason_no_show: "No-show without notice",
        reason_late_cancel: "Cancelled at the last minute",
        reason_other: "Other",
        badge: "Report",
        title: "Report Customer",
        description: "You are about to report the customer",
        description_sub: "Choose the reason for the report below:",
        other_reason_label: "Specify the reason",
        other_reason_placeholder: "Enter a reason...",
        confirm_btn: "Report"
      }
    },
    staff: {
      title: "Staff",
      subtitle: "Manage your team, permissions and roles.",
      new_staff: "New Staff",
      defaults: {
        first_name: "First Name",
        last_name: "Last Name",
        guest: "Guest"
      },
      invite_modal: {
        title: "Invite Staff",
        subtitle: "Send an invitation email to a new team member.",
        email_label: "Invitation Email",
        role_label: "Role",
        send_invite: "Send Invite",
        helper: "The member will receive a link to create their account."
      },
      card: {
        invite: "Invite",
        invite_pending: "Invite not accepted yet",
        role: "Role",
        status_label: "Status",
        verified: "Email Verified",
        not_verified: "Email Not Verified",
        deactivate: "Deactivate Account",
        activate: "Activate Account",
        details_title: "Staff Details",
        verify_account: "Verify Account",
        has_access: "User has access to the platform.",
        needs_confirm: "User must confirm email to access.",
        resend: "Resend",
        status: {
          active: "Active",
          inactive: "Inactive",
          holiday: "Holiday"
        }
      },
      details: {
        form: {
          first_name: "First Name",
          last_name: "Last Name",
          email: "Email",
          phone: "Phone",
          role: "Role"
        },
        verification_status: "Account Verification Status",
        verified: "Email Verified",
        pending: "Pending Confirmation",
        send_reset: "Send Reset Password",
        toast: {
          status_change: "User {{status}}",
          status_error: "Error changing status",
          self_deactivation_error: "You cannot deactivate your own account",
          self_deletion_error: "You cannot delete your own account",
          admin_deactivation_error: "You cannot deactivate an admin account as staff member",
          admin_deletion_error: "You cannot delete an admin account"
        },
        invite_delete: {
          title: "Delete Invite",
          description: "Are you sure you want to cancel this invite? The link sent via email will no longer be valid.",
          success: "Invite deleted",
          error: "Error while deleting"
        },
        confirm_deactivate: "Are you sure you want to deactivate this staff member? They will no longer have access.",
        confirm_activate: "Do you want to reactivate this staff member?",
        confirm_delete: "Are you sure you want to delete this staff member? This action is irreversible."
      },
      hours: {
        config_title: "Shift Configuration",
        config_desc: "Use the toggle on each day to activate/deactivate.",
        working: "Working",
        rest: "Rest",
        split: "Split",
        continuous: "Continuous",
        morning: "Morning",
        afternoon: "Afternoon",
        schedule: "Schedule",
        save: "Save Hours",
        toast: {
          saved: "Hours saved successfully"
        },
        error_morning: "Schedule {{day}}: Open time must be before break start.",
        error_break: "Schedule {{day}}: Break start must be before break end.",
        error_afternoon: "Schedule {{day}}: Break end must be before closing.",
        error_continuous: "Schedule {{day}}: Open time must be before closing."
      },
      timeoff: {
        vacation_tab: "Vacation (Days)",
        permission_tab: "Permissions (Hours)",
        vacation_planned: "Planned Vacation",
        permission_requested: "Requested Permissions",
        from: "From",
        to: "To",
        day: "Day",
        start_time: "From",
        end_time: "To",
        toast: {
          dates_missing: "Missing dates",
          date_end_error: "End date error",
          data_missing: "Missing data",
          added: "Added!",
          deleted: "Deleted!"
        },
        start_placeholder: "Start",
        end_placeholder: "End"
      },
      shiftchanges: {
        tab: "Shift Changes",
        planned: "Planned Shift Changes",
        open_time: "Open time",
        close_time: "Close time",
        break_start: "Break start",
        break_end: "Break end",
        break: "Break",
        toast: {
          added: "Shift change added!",
          deleted: "Shift change deleted!"
        }
      }
    },
    analytics: {
      title: "Analytics",
      subtitle: "Monitor your salon performance in real-time.",
      kpi: {
        revenue: "Total Revenue",
        appointments: "Appointments",
        avg_ticket: "Avg Ticket",
        new_customers: "New Customers"
      },
      charts: {
        revenue_trend: "Revenue Trend",
        revenue_subtitle: "Daily revenue for October",
        services_mix: "Services Mix",
        services_subtitle: "Distribution by category",
        staff_perf: "Staff Performance",
        top_products: "Top Products",
        view_stock: "View Stock",
        analyze_stock: "Stock Analysis",
        units_sold: "units sold"
      },
      export_excel: "Export Excel",
      exporting: "Exporting...",
      other: "Other"
    },
    email_confirmed: {
      title: "Email Verified!",
      subtitle: "Your email address has been successfully confirmed. Return to app to enjoy your new privileges!",
      button: "Open App",
      redirect: "Automatic app launch in {{count}}s",
    },
    salon: {
      title: "Your Salon",
      subtitle: "Manage profile, services, hours and reviews.",
      generate_link: "Salon Page",
      download_qr: "Download QR",
      qr_download_success: "QR Code successfully downloaded!",
      qr_download_error: "Error downloading the QR Code",
      tabs: {
        profile: "Profile",
        services: "Services",
        hours: "Hours & Holidays",
        gallery: "Gallery",
        reviews: "Reviews",
        trophies: "Goals",
        settings: "Settings"
      },
      profile: {
        general_info: "General Information",
        name: "Salon Name",
        vat: "VAT Number",
        desc: "Description",
        address: "Address",
        city: "Zip & City",
        contacts: "Contacts",
        edit_cover: "Edit Cover",
        delete: {
          title: "Delete Cover",
          description: "Are you sure you want to remove your salon's cover image?",
          confirm: "Remove Cover",
        },
        banner_updated: "Banner updated",
        banner_removed: "Banner removed",
        validation: {
          name_required: "Salon name required",
          vat_invalid: "Invalid VAT ID (11 digits required)",
          phone_required: "Phone number required",
          email_invalid: "Invalid email"
        },
        notifications: {
          title: "Notifications",
          settings_title: "Salon Settings",
          settings_constraints_label: "Calendar constraints",
          settings_constraints_desc: "If enabled, respects breaks, schedules, and holidays in calendar",
          dynamic_slots_label: "Dynamic slots",
          dynamic_slots_desc: "Enable dynamic slot visualization depending on the selected service in app",
          multicolor_label: "Multicolor appointments",
          multicolor_desc: "Color each appointment with a different rotating hue instead of the single orange color",
          max_booking_range_label: "Limit visible months in app",
          max_booking_range_desc: "Maximum number of months clients can book into the future",
          app_booking_label: "App bookings",
          app_booking_desc: "Enable or disable bookings through the application",
          appointments_label: "Appointment emails",
          appointments_desc: "Receive emails for new appointments and updates",
          max_reports_label: "Customer reports limit",
          max_reports_desc: "Maximum number of reports before the customer is blocked",
          cancellation_limit_label: "Cancellation limit hours",
          cancellation_limit_desc: "Up to how many hours in advance can a booking be cancelled",
          report_policy_label: "Message to the client if reported",
          report_policy_desc: "The text the client receives if they get reported. Keep it human and kind, not legal.",
          report_policy_placeholder: "Optional. E.g. \"Sorry it didn't work out! If you can't make it, let us know in time: cancelling is free up to 24h before.\""
        }
      },
      services: {
        new_service: "New Service",
        duration: "min",
        filters: {
          all: "All",
          all_staff: "All Staff",
          filter_staff: "Filter Staff",
        },
        empty_state: "No services found.",
        delete: {
          title: "Delete Service?",
          description: "You are about to remove \"{{name}}\". This action cannot be undone.",
          confirm: "Delete",
        },
        toast: {
          delete_success: "Service removed from menu",
          delete_error: "Error while deleting",
          create_success: "Service created successfully!",
          create_error: "Error creating service",
        },
        form: {
          name_label: "Service Name",
          name_placeholder: "e.g. Fade Cut",
          category_label: "Category",
          staff_label: "Who performs it?",
          select_staff: "Select Staff...",
          price_label: "Price",
          duration_label: "Duration",
          duration_placeholder: "Minutes",
          new_service_desc: "Add a new treatment to the menu.",
        }
      },
      hours: {
        opening_hours: "Opening Hours",
        holidays: "Holidays",
        add_period: "Add closure period",
        time_step: "Time Step",
        time_step_desc: "Choose the time interval (in minutes) to divide your agenda and services.",
        time_step_placeholder: "Select Time Step",
        time_step_updated: "Time step updated successfully",
        time_step_error: "Error updating time step",
        minutes_label: "{{minutes}} Minutes"
      },
      reviews: {
        based_on: "Based on",
        load_more: "Load more reviews"
      },
      trophies: {
        title: "Loyalty Program",
        subtitle: "Set milestones your customers can reach by booking through the app.\nThe more they book, the more they level up and unlock exclusive rewards.",
        active_levels: "Active Levels",
        add_level: "Add Level",
        empty_state: "No levels for this salon yet.",
        stat_participants: "Participating Clients",
        stat_redeemed: "Rewards Redeemed",
        level_prefix: "GOAL",
        threshold: "Achievement Threshold",
        bookings: "bookings",
        reward_prefix: "Wins:",
        delete_title: "Delete Level",
        delete_desc: "Are you sure you want to delete the level \"{{name}}\"?",
        delete_confirm: "Delete",
        toast: {
          updated: "Level updated",
          created: "Level created",
          deleted: "Level deleted",
          error: "An error occurred",
          delete_error: "Error deleting"
        },
        modal: {
          title_new: "New Goal",
          title_edit: "Edit Goal",
          subtitle: "Define a new milestone for your loyal customers.",
          name_label: "Level Name",
          name_placeholder: "e.g. Bronze Member",
          value_label: "Required Bookings",
          value_placeholder: "e.g. 10",
          value_helper: "The number of bookings required to unlock this level",
          prize_label: "Reward",
          prize_placeholder: "e.g. Free Cut",
          prize_helper: "What the customer wins once the goal is reached",
          create_btn: "Create Level",
          save_btn: "Save Changes"
        }
      }
    },
    billing: {
      title: "Billing & Plan",
      subtitle: "Manage your subscription and download invoices.",
      secure_payment: "Secure payments via Stripe",
      active_plan: "Active Plan",
      features: {
        unlimited_staff: "Unlimited Staff",
        staff_limit: "Max 2 Staff Members",
        bookings_limit: "Max 200 Bookings",
        unlimited_bookings: "Unlimited Bookings",
        unlimited_emails: "Unlimited Emails",
        advanced_agenda: "Advanced Digital Agenda",
        analytics: "Premium Analytics",
        support: "24/7 Priority Support"
      },
      usage_sms: "SMS Sent this month",
      manage_plan: "Manage Plan",
      upgrade_plan: "Upgrade Plan",
      invoices_history: "Invoice History",
      view_all_invoices: "View all invoices",
      payment_method: "Payment Method",
      next_renewal: "Next Renewal",
      renewal_text: "Automatic renewal on",
      update_method: "Update Method",
      help_title: "Need help?",
      help_text: "If you have questions about billing or want to upgrade, contact us.",
      contact_support: "Contact Support",
      month: "month",
      year: "year",
      expires: "Expires",
      status: {
        paid: "Paid",
        pending: "Pending",
        failed: "Failed"
      },
      ends_on: "Ends on:",
      plan_desc: "Everything you need to scale your salon.",
      no_invoices: "No invoices found",
      tabs: {
        plan: "Plan",
        visibility: "Visibility"
      },
      visibility_title: "Visibility Boost",
      visibility_desc: "Increase your salon visibility and attract more customers.",
      upgrade_boost_title: "Upgrade your boost",
      active_boost: "Active Boost",
      expires_on: "Expires on",
      upgrade_days: "Upgrade to {{days}} days",
      buy_btn: "Buy",
      packages: {
        boost_1: {
          title: "Super Boost",
          description: "Maximum visibility for 24 hours. Ideal for filling last minute gaps."
        },
        boost_7: {
          title: "Weekly Boost",
          description: "7 days of increased visibility. Perfect for weekly promotions.",
          badge: "SAVE 40%"
        },
        boost_15: {
          title: "Premium Boost",
          description: "15 days of maximum exposure. Dominate your area.",
          badge: "SAVE 63%",
          top_badge: "Best Seller"
        }
      }
    },
    products: {
      title: "Inventory",
      subtitle: "Manage stock, prices and supplier orders.",
      new_product: "New Product",
      stats: {
        value: "Stock Value",
        total: "Total Products",
        reorder: "To Reorder"
      },
      scan: "Scan",
      stock_low: "LOW STOCK",
      stock_label: "Stock",
      units: "units",
      products_lower: "products",
      search_placeholder: "Search by name, brand or code...",
      categories: {
        all: "All",
        haircare: "Haircare",
        styling: "Styling",
        color: "Color",
        equipment: "Equipment"
      }
    },
    media: {
      title: "Social Studio",
      subtitle: "Choose a template, customize it and publish in seconds.",
      generate_ai: "Generate with AI",
      no_templates: "No templates found.",
      filters: {
        all: "All",
        photo: "Photo",
        video: "Video"
      },
      categories: {
        all: "All",
        promo: "Promo",
        quote: "Quote",
        product: "Product",
        seasonal: "Seasonal",
        event: "Event"
      },
      editor: {
        customize: "Customize",
        customize_desc: "Edit template in real-time.",
        texts: "Texts",
        media: "Media",
        stickers: "Stickers & Link",
        replace_bg: "Replace Background",
        add_sticker: "Add Sticker",
        remove_sticker: "Remove Sticker",
        add_link: "Add Link",
        remove_link: "Remove Link",
        link_text: "Link Text (e.g. Book Now)",
        link_url: "Link URL (e.g. www.mysalon.com)",
        download: "Download Story",
        download_clip: "Download Clip",
        saved_success: "Media saved successfully!",
        title_placeholder: "Title",
        subtitle_placeholder: "Subtitle",
        cta_placeholder: "Call to Action"
      }
    },
    profile: {
      title: "My Profile",
      subtitle: "Manage your personal information and access.",
      personal_stats: "Personal Stats",
      today_appts: "Appointments Today",
      month_revenue: "Month Revenue",
      hours_worked: "Hours Worked Today",
      personal_data: "Personal Data",
      bio: "Bio (visible to clients)",
      security: "Security",
      password_last_changed: "Password: Last changed",
      change_password: "Change Password",
      mfa: "Two-Factor Authentication (2FA)",
      mfa_desc: "Add an extra layer of security to your account.",
      edit_profile: "Edit Profile",
      click_to_edit: "Click image to edit",
      roles: {
        owner_admin: "Owner & Master Admin",
        staff: "Staff Member",
        admin: "Admin",
        user: "User"
      },
      form: {
        current_password: "Current Password",
        new_password: "New Password",
        confirm_password: "Confirm Password",
        update_password: "Update Password",
        updating: "Updating..."
      },
      validation: {
        name_required: "First name required",
        surname_required: "Last name required",
        email_required: "Email required",
        password_mismatch: "Passwords do not match",
        fill_all: "Fill all password fields"
      },
      toast: {
        avatar_success: "Avatar updated successfully",
        avatar_error: "Error updating avatar",
        select_error: "Error selecting avatar",
        update_success: "Profile updated successfully!",
        update_error: "Error updating profile",
        password_success: "Password changed successfully!",
        password_error: "Error changing password",
        generic_error: "Generic error"
      },
      notifications: {
        title: "Notifications",
        appointments_label: "Appointment emails",
        appointments_desc: "Receive emails for new appointments and updates"
      }
    },
    new_shop: {
      hero: {
        title: "Create your salon",
        subtitle: "Start your adventure.",
        switch_account: "Want to switch account?"
      },
      form: {
        title: "New Salon",
        shop_name: "Salon Name",
        shop_email: "Salon Email",
        phone: "Phone",
        vat_id: "VAT ID",
        address: "Address",
        city: "City",
        zip: "ZIP Code",
        country: "Country",
        create_btn: "Create Salon",
        continue_btn: "Continue"
      },
      validation: {
        fill_all: "Fill all required fields",
        auth_error: "Authentication error. Reload and try again."
      },
      notifications: {
        creation_error: "Error creating salon",
        success: "Salon created successfully",
        loading: "Loading..."
      }
    },

    settings: {
      title: "Settings",
      subtitle: "Configure app preferences and integrations.",
      nav: {
        integrations: "Integrations",
        notifications: "Notifications",
        general: "General"
      },
      language: {
        title: "Language",
        desc: "Select the interface language.",
        it: "Italiano",
        en: "English"
      },
      integrations: {
        active: "Active Integrations",
        connect: "Connect",
        connected: "Connected"
      },
      notifications: {
        preferences: "Notification Preferences",
        labels: {
          new_booking: "New Bookings",
          new_booking_desc: "Receive a notification when a client books.",
          reminder: "Appointment Reminders",
          reminder_desc: "Notify me 15 minutes before every appointment.",
          report: "Weekly Report",
          report_desc: "Receive performance summary via email.",
          stock: "Stock Alert",
          stock_desc: "Notify when a product is running low."
        }
      },
      payments: {
        title: "Payments",
        desc: "Manage payments and billing.",
        stripe: "Stripe",
        connected: "Connected"
      },
      legal: {
        title: "Legal Notes",
        privacy: "Privacy Policy",
        terms: "Terms & Conditions"
      },
      support: {
        title: "Need help?",
        desc: "Our support team is available to solve any technical issues or questions regarding your account.",
        contact: "Contact Us"
      }
    },
    new_appointment: {
      title: "New Appointment",
      subtitle: "Enter booking details.",
      customer_label: "Customer",
      select_customer: "Select a customer",
      staff_label: "Staff",
      service_label: "Service",
      select_service: "Choose treatment",
      date_label: "Date",
      time_label: "Time",
      notes_label: "Internal Notes",
      notes_placeholder: "Allergies, preferences, extra details...",
      confirm_btn: "Add",
      staff_placeholder: "Select Staff...",
      service_fallback: "Service",
      success_message: "Appointment created successfully!",
      discount_or_markup_btn: "+ Discount or Markup",
      discount_or_markup_label: "Discount or Markup",
      discount_or_markup_placeholder: "Select type",
      value_label: "Value (€)",
      adjustment_type_none: "None",
      adjustment_type_discount: "Discount",
      adjustment_type_markup: "Markup",
      discount_too_high_error: "The discount exceeds the service price (€{{price}})",
      discount_too_high_error_toast: "The discount cannot exceed the service price"
    },
    notifications: {
      title: "Notifications",
      mark_read: "Mark all read",
      view_all: "View all notifications"
    },
    upgrade: {
      title: "Premium Feature",
      desc_generic: "This feature is not included in your plan. Upgrade to unlock it.",
      desc_ai: "The AI assistant, goals and advanced statistics are included in the AI plan. Upgrade to unlock them.",
      desc_inventory: "Inventory is included in the AI plan. Upgrade to unlock it.",
      cta: "Upgrade Now"
    },
    subscription: {
      hero: {
        title_simple: "Simple Plans.",
        title_power: "Pure Power.",
        subtitle: "Choose flexibility. Change or cancel anytime. \nNo hidden costs, ever.",
        monthly: "Monthly",
        annual: "Yearly",
        save_badge: "-20%"
      },
      plans: {
        pro: {
          name: "Pro",
          desc: "Everything you need to run your salon.",
          features: ["Unlimited bookings", "Up to 3 staff members", "Digital agenda & app", "Online booking 24/7", "Marketplace profile", "Email support"],
          btn: "Start with Pro"
        },
        ai: {
          name: "AI",
          desc: "Intelligence and growth for your team.",
          features: ["Everything in Pro", "Up to 10 staff members", "Unlimited AI & goals", "Advanced staff statistics", "Inventory management", "Marketing automations", "Google reviews", "WhatsApp support"],
          btn: "Upgrade to AI"
        },
        enterprise: {
          name: "Enterprise",
          desc: "For multi-location salons and big teams.",
          features: ["Everything in AI", "Unlimited staff members", "Multi-location", "Custom onboarding", "Dedicated support", "Monthly reports"],
          btn: "Contact Us"
        },
        standard: {
          name: "Standard",
          desc: "The essentials to get started.",
          features: ["Advanced Agenda", "Up to 2 Staff Members", "Up to 200 Bookings per month", "24/7 Support"],
          btn: "Start Now"
        },
        visibility: {
          name: "Visibility",
          desc: "Perfect for being present on the marketplace and acquiring new customers.",
          features: ["Marketplace Presence", "Salon Profile"],
          btn: "Buy Visibility"
        },
        professional: {
          name: "Professional",
          desc: "For those who want serious growth.",
          features: ["Everything in Standard", "Unlimited Staff", "Unlimited Bookings"],
          btn: "Upgrade to Pro"
        },
        business: {
          name: "Business +",
          desc: "Power for big brands.",
          features: ["Everything in Professional", "Custom Solutions", "Centralized Multi-location Mgmt", "Dedicated Account Manager"],
          btn: "Contact Us"
        },
        common: {
          popular: "Best seller",
          custom: "Custom",
          billed_yearly: "Billed yearly",
          billed_monthly: "Billed monthly",
          save_badge: "SAVE 20%",
          month: "month",
          year: "year"
        }
      },
      comparison: {
        title: "Detailed Comparison",
        features_header: "Features",
        categories: {
          core: "Core Features",
          experience: "Client Experience",
          marketing: "Marketing & Growth",
          management: "Management & Analytics",
          ai_goals: "AI & Goals",
          staff: "Team & Insights",
          support: "Support"
        },
        rows: {
          monthly_bookings: "Monthly Bookings",
          collaborators: "Staff Members",
          ai_assistant: "AI Assistant",
          goals_plans: "Goals & action plans",
          staff_performance: "Advanced staff statistics",
          staff_costs: "Cost per staff member",
          monthly_reports: "Monthly reports",
          marketing_automations: "Marketing automations",
          google_reviews: "Google reviews",
          custom_onboarding: "Custom onboarding",
          support_email: "Email support",
          support_whatsapp: "WhatsApp support",
          support_dedicated: "Dedicated support",
          digital_agenda: "Digital Agenda",
          mobile_app_admin: "Mobile App (Admin)",
          online_booking: "Online Booking 24/7",
          app_reminders: "Appointment Reminders",
          custom_app: "Custom Client App",
          waiting_list: "Auto Waiting List",
          marketplace: "Marketplace Profile",
          marketing_campaigns: "Marketing Campaigns",
          verified_reviews: "Verified Reviews",
          loyalty_program: "Loyalty Program",
          stock_management: "Stock Management",
          electronic_invoicing: "Electronic Invoicing",
          advanced_reports: "Advanced Reports",
          multi_location: "Multi-location"
        },
        values: {
          unlimited: "Unlimited",
          unlimited_staff: "Unlimited",
          unlimited_roles: "Unlimited + roles",
          email_only: "Email",
          email_push: "Email + Push",
          base: "Base",
          advanced: "Advanced",
          custom_kpi: "Custom KPI",
          up_to_200: "Up to 200",
          up_to_3: "Up to 3",
          up_to_10: "Up to 10",
          ai_unlimited: "Unlimited"
        }
      },
      footer: {
        doubts: "Questions?",
        subtitle: "Talk directly to us. We are fast, human and ready to help you set everything up.",
        book_demo: "Book a Demo",
        whatsapp: "Chat on WhatsApp",
        email_contact: "Send an Email"
      },
      demo: {
        title: "Choose the perfect time",
        subtitle: "Our experts will show you how Clip can transform your salon in 20 minutes.",
        close: "Close Calendar"
      },
      errors: {
        checkout_error: "Error creating checkout session",
        redirect: "Redirecting to checkout...",
        generic: "An unexpected error occurred."
      }
    },
    auth: {
      validation: {
        email_invalid: "Please enter a valid email address",
        password_required: "Password is required",
        name_min: "Name must be at least 2 characters",
        password_min: "Password must be at least 6 characters",
        terms_required: "You must accept Terms and Conditions",
        privacy_required: "You must accept Privacy Policy"
      },
      branding: {
        login: {
          title_prefix: "Your ",
          title_highlight: "dashboard",
          subtitle_prefix: "Your entire salon in a ",
          subtitle_highlight: "click",
          footer_text: "Don't have an account?",
          footer_btn: "Sign up now"
        },
        register: {
          title_highlight: "Welcome back",
          subtitle: "Join us and transform how you manage your work.",
          footer_text: "Already have an account?",
          footer_btn: "Sign in"
        },
        forgot: {
          title_prefix: "Don't ",
          title_highlight: "worry",
          subtitle: "It happens to everyone. We'll help you recover access in a moment.",
          footer_btn: "Back to Login"
        }
      },
      register: {
        full_name: "Full Name",
        terms_prefix: "I declare I have read and accept the ",
        terms_link: "Terms and Conditions",
        privacy_prefix: "I declare I have read the ",
        privacy_link: "Privacy Policy",
        submit_btn: "Register"
      },
      forgot: {
        email_sent_title: "Email Sent!",
        email_sent_desc: "If the address {{email}} is associated with an account, you will receive a password reset link.",
        recovery_email: "Recovery Email",
        submit_btn: "Send Link"
      },
      deactivated: {
        title: "Account Deactivated",
        subtitle: "Your access to the platform has been suspended.",
        what_to_do_title: "What to do?",
        what_to_do_desc: "If you are an employee, contact the salon owner to reactivate your account or contact support.",
        contact_support: "Contact Support",
        logout: "Logout and back to Login"
      },
      toasts: {
        login_error: "Login error",
        login_success: "Login successful",
        user_exists_title: "Account already exists!",
        user_exists_desc: "This email is already associated with an account. Log in with email or Google to activate your business profile.",
        register_error: "Registration error",
        register_success: "Registration completed!",
        reset_error: "Password reset error",
        reset_success: "Reset email sent",
        google_error: "Google login error",
        unexpected_error: "Unexpected error"
      },
      page: {
        login: {
          title: "Sign In",
          subtitle: "Enter your credentials to access."
        },
        register: {
          title: "Create Account",
          subtitle: "Fill in the details to get started."
        },
        forgot: {
          title: "Password Recovery",
          subtitle: "Enter your email to receive the reset link."
        },
        mobile: {
          no_account: "Don't have an account?",
          has_account: "Already have an account?",
          register_btn: "Sign Up",
          login_btn: "Sign In"
        },
        or_continue: "Or continue with",
        success: {
          title: "Check your email",
          desc: "We sent a confirmation link to your email address. Click the link to activate your account and start.",
          back_btn: "Back to Login"
        }
      },
      placeholders: {
        name: "Mario Rossi",
        email: "name@example.com"
      }
    },
    payment_success: {
      title: "Payment Completed!",
      message: "Payment completed successfully.",
      dashboard_btn: "Go to Dashboard",
      redirect: "Automatic redirect in {{count}}s"
    },
    booking_result: {
      confirmed_title: "Booking Confirmed!",
      confirmed_message: "The booking has been successfully confirmed.",
      cancelled_title: "Booking Cancelled",
      cancelled_message: "The booking has been cancelled as requested.",
      home_btn: "Return to Home"
    },
    referral: {
      box: {
        title: "Invite a salon",
        subtitle_prefix: "Get a discount code for ",
        subtitle_bold: "10% off",
        cta: "Invite Now"
      },
      dialog: {
        title: "Become an Ambassador",
        description: "Do you want to generate your referral code? It will be sent to {{email}}.",
        confirm_btn: "Generate Code",
        cancel_btn: "Cancel",
        loading: "Generating...",
        success: "Voucher sent to your email!",
        error: {
          no_email: "User email not found.",
          exists: "Voucher already requested! Check your email.",
          rate_limit: "Too many attempts. Wait an hour.",
          generic: "Error during generation. Try again.",
          connection: "Connection error."
        }
      }
    }

  }
};